import { memo, useRef, useState } from 'react';

import { Box, Menu } from '@mui/material';

import { MenuModulesNodeList } from 'components/header/menu-modules/desktop/MenuModulesNodeList';
import { MenuModulesItem } from 'components/header/menu-modules/MenuModulesItem';
import { MenuNode } from 'components/header/menu-modules/types';

type MenuModulesSubmenu = {
    node: MenuNode;
    onClose(): void;
};

/**
 * Submenu do menu principal.
 * Abre ao passar o mouse sobre o menu-leaf pai.
 */
export const MenuModulesSubmenu = memo(function MenuModulesSubmenu({ node, onClose }: MenuModulesSubmenu) {
    const menuItemRef = useRef<HTMLLIElement>(null);
    const [open, setOpen] = useState(false);

    /**
     * Fecha o submenu e o menu principal.
     */
    const handleCloseAll = () => {
        setOpen(false);

        onClose();
    };

    return (
        <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
            <MenuModulesItem node={node} ref={menuItemRef} />

            <Menu
                anchorEl={menuItemRef.current}
                style={{ pointerEvents: 'none' }}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                open={open}
                autoFocus={false}
                disableAutoFocus
                disableEnforceFocus
                disablePortal
                onClose={() => setOpen(false)}
                slotProps={{
                    transition: { timeout: 100 },
                    paper: { sx: { minWidth: 180 } },
                }}
            >
                <MenuModulesNodeList nodes={node.children || []} onClose={handleCloseAll} />
            </Menu>
        </Box>
    );
});
